// root state object.
// each Vuex instance is just a single state tree.
const state = {
    availableVideosList: [{
        id: 1,
        title: 'Video webtv-solution title movie 1',
        duration: '00:05:00',
        sources: [{
            src: '//argueii-web-dev.webtv-solution.com/uep_v2/videos/movie.mp4',
            type: 'video/mp4'
        }],
        poster: 'http://media.w3.org/2010/05/bunny/poster.png'
    },
    {
        id: 2,
        title: 'Video webtv-solution title movie 2',
        duration: '00:00:30',
        sources: [{
            src: '//argueii-web-dev.webtv-solution.com/uep_v2/videos/movie2.mp4',
            type: 'video/mp4'
        }],
        poster: 'http://media.w3.org/2010/05/bunny/poster.png'
    }],
};

// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
    /**
     * Add video to the available videos list
     *
     * @function   addVideoToAvailableList
     */
    addVideoToAvailableList (state, video) {
        if (state.availableVideosList.filter(e => e.id === video.id).length === 0) {
            state.availableVideosList.push(video);
        }
    },
    /**
     * Changed the content of the available videos list
     *
     * @function   updateVideoAvailableList
     */
    updateVideoAvailableList (state, videosList) {
        state.availableVideosList = videosList;
    },
    /**
     * Delete the content of the available videos list
     *
     * @function   clearVideoAvailableList
     */
    clearVideoAvailableList (state) {
        state.availableVideosList = state.availableVideosList.slice(0, 2);
    }
};

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
    addVideoToAvailableList: ({ state, commit }, video) => commit('addVideoToAvailableList', video),
    updateVideoAvailableList: ({ state, commit }, videosList) => commit('updateVideoAvailableList', videosList),
    clearVideoAvailableList: ({ commit }) => commit('clearVideoAvailableList'),
};

// getters are functions
const getters = {
    /**
     * Get availableVideosList
     */
    getAvailableVideosList:  state => state.availableVideosList
};

export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./demo/store/modules/available-videos.js